import { render, staticRenderFns } from "./ListaTelefonePessoa.vue?vue&type=template&id=19dca604"
import script from "./ListaTelefonePessoa.vue?vue&type=script&lang=js"
export * from "./ListaTelefonePessoa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports